import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import TotalSavings from './TotalSavings';
import DaySelector from './DaySelector';
import { Wrapper } from './elements';

const deps = {
  showTutorial: state.challenge.tutorial.show,
  tutorialLength: state.challenge.tutorial.length,
};

function TopBar({
  showTutorial,
  tutorialLength,
}: typeof deps & ConnectedProps): React.ReactElement {
  return (
    <Wrapper $highlight={showTutorial === tutorialLength}>
      <TotalSavings />
      <DaySelector />
    </Wrapper>
  );
}

export default connect(deps, TopBar);
